import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { api } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

let instance: AxiosInstance;
// let eventInstance: AxiosInstance;

const axiosInstance = async () => {
  instance = axios.create({
    baseURL: api + "/api/v1/bulkUpload",
  });
  // Attach 403 refresh-and-retry interceptor
  attachRefreshInterceptor(instance);

  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
};

axiosInstance();

export const bulkUploadEmployee = async (formData: FormData, onUploadProgress: any) => {
  return instance.post(`/employee`, formData, onUploadProgress);
};

export const getFormatFileEmployee = async (): Promise<string> => {
  return instance.get("/employee-format");
};

export const getFormatFileCounter = async (): Promise<string> => {
  return instance.get("/counter-format");
};
export const bulkUploadCounter = async (formData: FormData, onUploadProgress: any) => {
  return instance.post(`/counter`, formData, onUploadProgress);
};
